import styled, { css } from 'styled-components';

import { ReactComponent as TrashIconBase } from 'assets/icons/primary-trash.svg';

import { TrashIconStylesProps } from './DeleteSchedule.types';

export const TrashIcon = styled(TrashIconBase)<TrashIconStylesProps>(
  ({ disabled, theme: { palette } }) => css`
    cursor: ${disabled ? 'default' : 'pointer'};
    opacity: ${disabled ? 0.5 : 1};
    width: 24px;
    height: 24px;
    vertical-align: middle;

    path {
      fill: ${disabled ? palette.grey[600] : '#2D6CE6'};
    }
  `,
);
